import { render, staticRenderFns } from "./RecoveryFee.vue?vue&type=template&id=3ebe351c&scoped=true&"
import script from "./RecoveryFee.vue?vue&type=script&lang=js&"
export * from "./RecoveryFee.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryFee.vue?vue&type=style&index=0&id=3ebe351c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebe351c",
  null
  
)

export default component.exports